import React, { FC, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StatusUpdateState } from 'api/status-updates';
import {
  putStatusUpdates,
  selectActiveStatusUpdate,
  setActiveStatusUpdate,
} from 'data/status-updates';
import { useActiveStatUpdateCCs } from './cc-hooks';
import { EmailInviteSelect, EmailVal } from './email-invite-select';

export const StatusUpdateCC: FC<{
  userEmails: EmailVal[];
  setUserEmails: (users) => void;
}> = ({ userEmails, setUserEmails }) => {
  const activeStatusUpdate = useSelector(selectActiveStatusUpdate);
  const ccEmails = useActiveStatUpdateCCs();

  const dispatch = useDispatch();

  const isPublished = activeStatusUpdate?.state === StatusUpdateState.Published;
  const ccOptions = useMemo(() => {
    return isPublished
      ? []
      : ccEmails.map((email) => {
          return { label: email, value: email };
        });
  }, [ccEmails, isPublished]);

  if (!activeStatusUpdate) {
    return null;
  }

  const onEmailsAdd = (formEmails) => {
    const updatedStatusUpdate = {
      ...activeStatusUpdate,
      ccUsers:
        formEmails.filter(Boolean).map(({ value }) => {
          return { emailId: value };
        }) || [],
    };

    if (activeStatusUpdate?.state === StatusUpdateState.Draft) {
      dispatch(setActiveStatusUpdate(updatedStatusUpdate));

      dispatch(
        putStatusUpdates({
          statusUpdate: updatedStatusUpdate,
        }),
      );
    }
  };

  return (
    <EmailInviteSelect
      activeStatusUpdate={activeStatusUpdate}
      onEmailsAdd={onEmailsAdd}
      userEmails={userEmails}
      setUserEmails={setUserEmails}
      ccOptions={ccOptions}
    />
  );
};
